//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';
import { translate } from "react-i18next";
import DefaultButton from './../../components/DefaultButton';
import GhostButton from './../../components/GhostButton';
import TextInput from './../../components/TextInput';
import MainPageContainer from './../../components/MainPageContainer';
import { RECAPTCHA_SITE_KEY } from './../../config';
import { registerGuest } from './../../actions/auth';
import {
    AXIOS_INSTANCE,
} from './../../types/auth';
import messageManager from './../../utilities/messageManager';
import loading from './../../utilities/loading';
import { signOut } from './../../actions/auth';

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: calc(100% - 40px);
    margin: 15px;
`;

const FlexForm = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

type State = {
    password: string,
    repeatedPassword: string,
    invalidPassword: boolean,
    login: string,
    invalidLogin: boolean,
    forename: string,
    invalidForename: boolean,
    surname: string,
    invalidSurname: boolean,
    customerName: string,
    invalidCustomerName: boolean,
    phoneNumber: string,
    recaptchaResponse: string,
    registerDisabled: boolean,
};


type Props = {
    axiosInstance: any,
    t: (text: string) => {},
    registerGuest: (axiosInstance: Object,
        {
            password: string,
            invalidPassword: boolean,
            login: string,
            invalidLogin: boolean,
            forename: string,
            invalidForename: boolean,
            surname: string,
            invalidSurname: boolean,
            customerName: string,
            invalidCustomerName: boolean,
            phoneNumber: string,
        },
        recaptchaResponse: string) => void,
}

export class SignIn extends React.Component<Props, State> {
    constructor(): void {
        super();
        this.state = {
            password: '',
            repeatedPassword: '',
            invalidPassword: false,
            login: '',
            invalidLogin: false,
            forename: '',
            invalidForename: false,
            surname: '',
            invalidSurname: false,
            customerName: '',
            invalidCustomerName: false,
            phoneNumber: '',
            recaptchaResponse: '',
            registerDisabled: false,
        };
    }

    handleSubmit() {
        const { BASE_URL, t, axiosInstance } = this.props;
        const { login, password, forename, surname, customerName, phoneNumber, recaptchaResponse } = this.state;
        this.validateForm((formInvalid) => {
            if (!formInvalid) {

                loading.start();
                this.setState({ registerDisabled: true })
                axiosInstance.post(
                    `${BASE_URL}account/register-guest`,
                    {
                        login: login,
                        password: password,
                        forename: forename,
                        surname: surname,
                        customerName: customerName,
                        phoneNumber: phoneNumber,
                        recaptchaResponse: recaptchaResponse,
                        language: localStorage.getItem("language")
                    })
                    .then((result) => {
                        messageManager.show({
                            type: 'info',
                            text: t('Confirmation mail has been sent')
                        })
                        loading.stop();
                        window.grecaptcha.reset();
                        this.setState({ registerDisabled: false })
                        setTimeout(() => {
                            window.location.replace('./#/signin')
                        }, 4000)
                    })
                    .catch((error) => {
                        messageManager.show({
                            text: t(error.response.data),
                            type: 'error',
                        })
                        loading.stop();
                        window.grecaptcha.reset();
                        this.setState({ registerDisabled: false })
                    })
            }
        })
    }
    //TODO: przemyśleć walidację - jakaś osobna metoda?
    validateForm(callback) {
        const { password, repeatedPassword, login, forename, surname, customerName } = this.state;
        let invalidPassword = false,
            invalidLogin = false,
            invalidForename = false,
            invalidSurname = false,
            invalidCustomerName = false;
        if (password === "" || password !== repeatedPassword || repeatedPassword === "")
            invalidPassword = true
        if (login === "")
            invalidLogin = true
        if (forename === "")
            invalidForename = true
        if (surname === "")
            invalidSurname = true
        if (customerName === "")
            invalidCustomerName = true
        this.setState({
            invalidPassword: invalidPassword,
            invalidLogin: invalidLogin,
            invalidForename: invalidForename,
            invalidSurname: invalidSurname,
            invalidCustomerName: invalidCustomerName,
        },
            callback(invalidPassword || invalidLogin || invalidForename || invalidSurname || invalidCustomerName));
    }

    render(): React.Node {
        const {
            password,
            repeatedPassword,
            invalidPassword,
            invalidRepeatedPassword,
            login,
            invalidLogin,
            forename,
            invalidForename,
            surname,
            invalidSurname,
            customerName,
            invalidCustomerName,
            phoneNumber,
            registerDisabled,
        }: State = this.state;
        const { t }: Props = this.props;
        return (
            <MainPageContainer
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    width: '100%',
                }}>
                <FlexForm onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleSubmit();
                }}>
                    <input type="submit" value="Submit" style={{ display: 'none' }} />

                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="email"
                        placeholder="example@mail.com"
                        autoComplete="email"
                        required
                        name="email"
                        value={login}
                        tip={t("We'll send you confirmation link to this address")}
                        onChange={event => {
                            this.setState({ login: event.target.value });
                        }}
                        invalid={invalidLogin}
                        onBlur={event => {
                            const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            if (reg.test(login.toLowerCase())) {
                                this.setState({
                                    invalidLogin: false,
                                })
                            }
                            else {
                                this.setState({
                                    invalidLogin: true,
                                })
                            }
                        }}
                    />

                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="text"
                        placeholder={t('Customer name')}
                        required
                        name="customerName"
                        value={customerName}
                        tip={t("Your company name or your username")}
                        onChange={event => {
                            this.setState({ customerName: event.target.value });
                        }}
                        invalid={invalidCustomerName}
                        onBlur={event => {
                            if (customerName === '')
                                this.setState({ invalidCustomerName: true })
                            else
                                this.setState({ invalidCustomerName: false })
                        }}
                    />

                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="text"
                        placeholder={t('First name')}
                        autoComplete="given-name"
                        name="fname"
                        value={forename}
                        tip={t("We need your forename for account verification")}
                        onChange={event => {
                            this.setState({ forename: event.target.value });
                        }}
                        invalid={invalidForename}
                        onBlur={event => {
                            if (forename === '')
                                this.setState({ invalidForename: true })
                            else
                                this.setState({ invalidForename: false })
                        }}
                    />

                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="text"
                        placeholder={t('Last name')}
                        autoComplete="family-name"
                        name="lname"
                        value={surname}
                        tip={t("We need your surname for account verification")}
                        onChange={event => {
                            this.setState({ surname: event.target.value });
                        }}
                        invalid={invalidSurname}
                        onBlur={event => {
                            if (surname === '')
                                this.setState({ invalidSurname: true })
                            else
                                this.setState({ invalidSurname: false })
                        }}
                    />

                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="password"
                        placeholder={t('Password')}
                        required
                        name="password"
                        value={password}
                        tip={t("Type 6 characters or more")}
                        onChange={event => {
                            this.setState({
                                password: event.target.value
                            })
                        }}
                        invalid={invalidPassword}
                        onBlur={event => {
                            if (password.length < 6)
                                this.setState({ invalidPassword: true })
                            else
                                this.setState({ invalidPassword: false })
                        }}
                    />

                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="password"
                        placeholder={t('Confirm password')}
                        required
                        name="confirm password"
                        value={repeatedPassword}
                        tip={t("Type your password again")}
                        onChange={event => {
                            this.setState({
                                repeatedPassword: event.target.value
                            })
                        }}
                        invalid={invalidRepeatedPassword}
                        onBlur={() => {
                            if (repeatedPassword !== password) {
                                this.setState({
                                    invalidRepeatedPassword: true,
                                })
                            }
                            else {
                                this.setState({
                                    invalidRepeatedPassword: false,
                                })
                            }
                        }}
                    />

                    <TextInput
                        style={{ width: '265px', margin: '5px' }}
                        type="tel"
                        placeholder={t('Phone')}
                        autoComplete="tel"
                        name="phone"
                        value={phoneNumber}
                        tip={t("We'll contact you if you have a problem with our app")}
                        onChange={event => {
                            this.setState({ phoneNumber: event.target.value });
                        }} />

                    <ReCAPTCHA
                        style={{
                            margin: '5px 10px'
                        }}
                        ref="recaptcha"
                        sitekey={RECAPTCHA_SITE_KEY}
                        onChange={(resposne) => { this.setState({ recaptchaResponse: resposne }) }}
                    />

                    <ButtonWrapper>
                        <GhostButton
                            onClick={() => {
                                this.props.signOut();
                                window.location.replace('./#/signin')
                            }}
                            style={{
                                height: '25px',
                                width: '50px',
                                display: 'flex',
                                marginRight: '5px',
                            }}>
                            {`${t('Back')}`}
                        </GhostButton>

                        <DefaultButton
                            style={{
                                width: '90px',
                                marginLeft: '5px',
                            }}
                            tabIndex='0'
                            disabled={registerDisabled}
                            onClick={(e) => {
                                this.handleSubmit();
                            }}>
                            {t('Register')}
                        </DefaultButton>
                    </ButtonWrapper>
                </FlexForm>
            </MainPageContainer >
        );
    }
};

const mapStateToProps = state => ({
    [AXIOS_INSTANCE]: state.auth.get(AXIOS_INSTANCE),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    registerGuest,
    signOut,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(SignIn));


// WEBPACK FOOTER //
// ./src/containers/register/Register.jsx